import * as React from 'react'
import { Box } from '@mui/material'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'
import HandymanRoundedIcon from '@mui/icons-material/HandymanRounded'
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded'

export default function CompactAssetIcon({
    iconUrl,
    itemType = 'resource',
    size = 48,
    sx
}) {
    const iconSize = Math.max(Number(size) || 48, 24)
    const fallbackIcon =
        itemType === 'tool' ? <HandymanRoundedIcon sx={{ fontSize: Math.max(20, iconSize - 12), color: '#d6e2f7' }} /> :
            itemType === 'troop' ? <GroupsRoundedIcon sx={{ fontSize: Math.max(20, iconSize - 12), color: '#d6e2f7' }} /> :
                <Inventory2RoundedIcon sx={{ fontSize: Math.max(20, iconSize - 12), color: '#d6e2f7' }} />

    return (
        <Box
            sx={{
                width: iconSize,
                height: iconSize,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                overflow: 'hidden',
                backgroundColor: 'transparent',
                ...sx
            }}
        >
            {iconUrl ? (
                <Box
                    component="img"
                    src={iconUrl}
                    alt=""
                    loading="lazy"
                    sx={{
                        width: iconSize,
                        height: iconSize,
                        objectFit: 'contain',
                        pointerEvents: 'none'
                    }}
                />
            ) : fallbackIcon}
        </Box>
    )
}
